import { Menu } from '@components/ui/menu';
import { useCopyTask } from '@services/jobs/tasks/copy';
import { JobStageMenuProps } from './types';
import { cn } from '@utils/cn';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { useTranslation } from 'react-i18next';
import { useCreateTask } from '@services/jobs/tasks/create';
import { multischeduleEnabled, uuidRegEx } from '@utils/consts';
import { useState } from 'react';
import { NewTask } from '@root/globalTypes';
import { JobStageScheduleDialog } from './scheduleDialog';

export const JobStageMenu = ({ jobId, stageId, multi }: JobStageMenuProps) => {
  const { t } = useTranslation('app');
  const [open, setOpen] = useState<boolean>(false);
  const [scheduleTask, setScheduleTask] = useState<NewTask>();
  const isMulti = Boolean(multi?.length);

  const createMulti = useCopyTask();
  const createTask = useCreateTask();
  const isLoading = createTask.isLoading || createMulti.isLoading;

  const handleItemClick = (callback: () => void) => {
    setOpen(false);
    callback();
  };

  const addTask = ({ id, stageName, name }: NewTask) => {
    if (!uuidRegEx.test(id)) createTask.mutate({ jobId, taskName: id, stageId, stageName });
    else createMulti.mutate({ jobId, taskName: name, originalTaskId: id, stageId });
  };

  const handleAddNew = (task: NewTask) => {
    if (isLoading) return;
    handleItemClick(() => {
      if (multischeduleEnabled && task.scheduleType === 'internal') setScheduleTask(task);
      else addTask(task);
    });
  };

  return (
    <>
      <Menu
        open={open}
        setOpen={setOpen}
        options={[
          {
            group: {
              id: 'job-stage-menu-add-new',
              name: t('pages.job.addNew'),
            },
            items: multi.map((task) => ({
              id: task.id,
              name: task.name,
              callback: () => handleAddNew(task),
            })),
          },
        ]}>
        <button
          className={cn([
            'flex h-6 w-6 items-center justify-center text-lg text-neutral-400 hover:text-primary-500 disabled:text-neutral-400 disabled:opacity-30',
            open && 'text-primary-500',
          ])}
          disabled={!isMulti || isLoading}
          type="button"
          onClick={(e) => {
            if (isLoading) return;
            e.stopPropagation();
            setOpen(!open);
          }}>
          <SvgConsumer id="jobStageMenu" />
        </button>
      </Menu>
      {multischeduleEnabled && (
        <span className="contents" onClick={(e) => e.stopPropagation()}>
          <JobStageScheduleDialog
            jobId={jobId}
            stageId={stageId}
            task={scheduleTask}
            setTask={setScheduleTask}
            onAddWithoutSchedule={addTask}
          />
        </span>
      )}
    </>
  );
};
